export const ADD_PROBLEM = 'ADD_PROBLEM';
export const FETCH_PROBLEM = 'FETCH_PROBLEM';
export const FETCH_FILTERED_ACTION = 'FETCH_FILTERED_ACTION';
export const FETCH_FILTERED_PROBLEM = 'FETCH_FILTERED_PROBLEM';
export const FETCH_SINGLE_ACTION = 'FETCH_SINGLE_ACTION';
export const FETCH_SINGLE_PROBLEM = 'FETCH_SINGLE_PROBLEM';
export const FETCH_KEYWORDS = 'FETCH_KEYWORDS';
export const EDIT_PROBLEM = 'EDIT_PROBLEM';
export const EDIT_CAUSE = 'EDIT_CAUSE';
export const ADD_CAUSE = 'ADD_CAUSE';
export const DELETE_CAUSE = 'DELETE_CAUSE';
export const FETCH_PROBLEM_HISTORY = 'FETCH_PROBLEM_HISTORY';
export const ADD_ACTION = 'ADD_ACTION';
export const EDIT_ACTION = 'EDIT_ACTION';
export const DELETE_ACTION = 'DELETE_ACTION';
export const SEND_REPORT = 'SEND_REPORT';
export const DELETE_PROBLEM = 'DELETE_PROBLEM';
export const ARCHIVE_PROBLEM = 'ARCHIVE_PROBLEM';
export const RESTORE_PROBLEM = 'RESTORE_PROBLEM';

export default {
  ADD_PROBLEM,
  FETCH_PROBLEM,
  FETCH_FILTERED_ACTION,
  FETCH_FILTERED_PROBLEM,
  FETCH_SINGLE_ACTION,
  FETCH_SINGLE_PROBLEM,
  FETCH_KEYWORDS,
  EDIT_PROBLEM,
  EDIT_CAUSE,
  ADD_CAUSE,
  DELETE_CAUSE,
  FETCH_PROBLEM_HISTORY,
  ADD_ACTION,
  EDIT_ACTION,
  DELETE_ACTION,
  SEND_REPORT,
  DELETE_PROBLEM,
  ARCHIVE_PROBLEM,
  RESTORE_PROBLEM,
};
